import { killStream } from './fake-filesystem.js';

var closeSoundStream = async (_, payload, __) => {
    if (payload.functionName === 'onCloseSoundStream') {
        killStream(payload.arguments[0]);
    }
};

export { closeSoundStream as default };
